export const checkRefereeWishDay = (
  referee,
  dayId,
  startTime = null,
  endTime = null
) => {
  let value = (referee.availability || {})[dayId];
  if (value === undefined) {
    value = "all";
  }
  if (value === "none") {
    return false;
  } else if (value !== "all" && value !== "none") {
    if (!value.start && !value.end) {
      return false;
    } else {
      if (startTime && endTime) {
        let startValid = !value.start || startTime >= value.start;

        let endValid = !value.end || endTime <= value.end;

        return startValid && endValid;
      } else {
        return true;
      }
    }
  } else {
    return true;
  }
};
